import { render, staticRenderFns } from "./NavlinkDialog.vue?vue&type=template&id=b8335fa4&"
import script from "./NavlinkDialog.vue?vue&type=script&lang=js&"
export * from "./NavlinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports